// extracted by mini-css-extract-plugin
export default {"addressLabel":"CustomField_addressLabel__Y3MRC","maxWidth":"CustomField_maxWidth__-xJ8o"};